
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as GoodIconComponent } from "./good-icon.svg";

export const GoodIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <GoodIconComponent {...props} />;
};
